import React from "react";
import { LocationInfo } from "../shared/models/Location";
import { MapActions } from "./Map.action";
import { MapState } from "./Map.state";
import { ReducedContext } from "../shared/util/ReducedContext";

export interface MapContextType {
  locations: Array<LocationInfo>;
  mapRef: google.maps.Map | null;
  query: string | null;
  regionalOperationCenter: boolean;
  selectedLocation: LocationInfo | null;
}

const defaultMapContext: ReducedContext<MapActions, MapState> = {
  state: {
    locations: [],
    mapRef: null,
    query: null,
    regionalOperationCenter: false,
    selectedLocation: null
  },
  dispatch: () => {}
};

export const MapContext = React.createContext(defaultMapContext);
